import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { Capacitor } from '@capacitor/core';
import { IS_NEW_UI_FLOW } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthGuardService {
  private authService = inject(AuthService);
  private router = inject(Router);

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    // const returningUser = await Storage.get({ key: 'returningUser' });

    const roleMinimumValue: any = route.data.roleMinimumValue;
    let url = state.url;

    // Store returnTo URL in localStorage for deep links (both authenticated and non-authenticated)
    if (url && url !== '/' && (Capacitor.isNativePlatform() || url.includes('/join')) || url.includes('/my-teams')) {
      localStorage.setItem('returnTo', url);
    }

    if (!(await this.authService.isAuthenticated())) {

      const authRoute = IS_NEW_UI_FLOW ? 'auth' : 'login';
      Capacitor.isNativePlatform() || url.includes('/join') || url.includes('/my-teams')
        ? this.router.navigate([authRoute], { queryParams: { returnTo: url } })
        : this.router.navigate(['home']);


      return false;
    } else if (roleMinimumValue) {
      return this.authService.authUserSignal()?.role.value > roleMinimumValue
        ? true
        : false;
    }

    return true;
  }
}
